export default {
  green: "#4CAF50",
  white: "#ffffff",
  black: {
    "500": "#4A4459",
    "900": "#000000",
  },
  purple: {
    dark: "#65558F",
  },
};
